document.addEventListener("DOMContentLoaded", function(){
    const body = document.querySelector('body')
    const hamburgerBtns = document.querySelectorAll('.menu-mobile-button .icon-hamburger')
    const closeBtns = document.querySelectorAll('.menu-mobile-button .icon-close') 
    const mobileFooterDropdown = document.querySelectorAll('.menu-mobile-footer .item.has-dropdown')
    const nav2Slider = document.querySelector('.menu-mobile .item.nav2 .submenu-flex')
    const featuredCollectionsSliders = document.querySelectorAll('.featured-collections-submenu-flex')

    hamburgerBtns.forEach(btn => {
        btn.addEventListener('click', e => {
            e.preventDefault();
            hamburgerBtns.forEach(btn => btn.classList.toggle('hide'))
            closeBtns.forEach(btn => btn.classList.toggle('show'))
            body.classList.toggle('mobile-menu-open')
        })
    })

    closeBtns.forEach(btn => {
        btn.addEventListener('click', e => {
            e.preventDefault();
            closeBtns.forEach(btn => btn.classList.toggle('show'))
            hamburgerBtns.forEach(btn => btn.classList.toggle('hide'))
            body.classList.toggle('mobile-menu-open')
        })
    })

    mobileFooterDropdown.forEach(el => {
        el.addEventListener('click', () => {
            console.log('click')
            el.classList.toggle('active')
            el.lastChild.classList.toggle('submenu-open')
        })
    })
    
    if (nav2Slider) {
        $(nav2Slider).slick({
            infinite: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            vertical: false
          })
    }

    featuredCollectionsSliders.forEach(featuredCollectionsSlider => {
        $(featuredCollectionsSlider).slick({
            infinite: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            vertical: false
        })
    });
  });